import React from 'react';
import { Tabs } from 'antd';
import { CalendarOutlined, SettingOutlined } from '@ant-design/icons';
import AmenityBooking from './AmenityBooking';
import { AmenityManagement } from './AmenityManagement';
import { useAuth } from '../../../context/UnifiedAuthContext';

/**
 * S11.2 — Consolidated Amenities hub.
 * Combines "Amenity Booking" (resident-facing) and "Amenity Management" (admin-only)
 * into a single page with role-aware tabs.
 */
const Amenities: React.FC = () => {
  const { user } = useAuth();
  const isAdmin =
    user?.role === 'admin' ||
    user?.role === 'super_admin_condo' ||
    user?.role === 'superadmin';

  const items = [
    {
      key: 'bookings',
      label: (
        <span>
          <CalendarOutlined />
          &nbsp;Bookings
        </span>
      ),
      children: <AmenityBooking />,
    },
    ...(isAdmin
      ? [
          {
            key: 'manage',
            label: (
              <span>
                <SettingOutlined />
                &nbsp;Manage Amenities
              </span>
            ),
            children: <AmenityManagement />,
          },
        ]
      : []),
  ];

  return (
    <Tabs
      items={items}
      size="large"
      destroyInactiveTabPane={false}
      style={{ marginTop: -8 }}
    />
  );
};

export default Amenities;
